import { Component, OnInit, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { UtilsService } from '../../shared/utils.service';
import { TranslationService } from '../../shared/translation.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { GTMService } from '../../shared/gtm.service';

const KEY_PREFIX = 'yearInReviewBanner.image';
const REVIEW_URL_KEY = 'oeapp.home.yearInReviewUrl';
const GTM_CLICK_EVENT = 'YEAR_IN_REVIEW_banner_click';

enum ImageSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  HUGE = 'huge'
}

const BREAKPOINT_MAP = {
  [ImageSizes.SMALL]: 0,
  [ImageSizes.MEDIUM]: 768,
  [ImageSizes.LARGE]: 992,
  [ImageSizes.HUGE]: 1200
};

@Component({
  selector: 'lp2-year-in-review-banner',
  template: `
    <img (click)="openReview()" [src]="imageSrc | translate" alt="Year in Review Banner" />
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      margin-top: 1rem;
      cursor: pointer;
    }
    img {
      width: 100%;
      display: block;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'container'
  }
})
export class YearInReviewBannerComponent implements OnInit {
  public imageSrc: string = '';

  constructor(
    private readonly translationService: TranslationService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.updateImage();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.updateImage();
  }

  public openReview(): void {
    window.open(this.translationService.translate(REVIEW_URL_KEY) + this.oeAppPersonService.contactId, '_blank');
    this.gtmService.sendGA4Event(GTM_CLICK_EVENT);
  }

  private updateImage(): void {
    this.imageSrc = KEY_PREFIX + '.' + this.getBreakpoint();
  }

  private getBreakpoint(): ImageSizes {
    return UtilsService.objectEntries(BREAKPOINT_MAP)
      .reduce((acc, [key, value]: [ImageSizes, number]) => {
        if (window.innerWidth >= value) {
          return key;
        }
        return acc;
      }, ImageSizes.SMALL);
  }
}



// WEBPACK FOOTER //
// ./ts/app/components/year-in-review-banner/year-in-review-banner.component.ts